import { Box, Stack } from "@mui/material";
import { Typography } from "@platform/design-system";

import { MAX_CHARACTERS } from "./constants";

import type { SaveState } from "./types";

interface CarrierNotesFooterProps {
  characterCount: number;
  saveState: SaveState;
  lastSavedTimestamp: number | null;
}

const getSaveStatusText = (
  saveState: SaveState,
  lastSavedTimestamp: number | null,
): string => {
  switch (saveState) {
    case "unsaved":
      return "Unsaved changes";
    case "saving":
      return "Saving...";
    case "saved": {
      if (!lastSavedTimestamp) return "No unsaved changes";
      const secondsAgo = Math.floor((Date.now() - lastSavedTimestamp) / 1000);
      if (secondsAgo < 10) return "Last saved just now";
      if (secondsAgo < 60) return `Last saved ${secondsAgo}s ago`;
      return `Last saved ${Math.floor(secondsAgo / 60)}m ago`;
    }
    case "error":
      return "Failed to save";
    default:
      return "";
  }
};

const CarrierNotesFooter = ({
  characterCount,
  saveState,
  lastSavedTimestamp,
}: CarrierNotesFooterProps): React.JSX.Element => {
  const isOverLimit = characterCount > MAX_CHARACTERS;

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "grey.50",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          variant="caption"
          color={isOverLimit ? "danger" : "textSecondary"}
        >
          {characterCount}/{MAX_CHARACTERS} characters
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {getSaveStatusText(saveState, lastSavedTimestamp)}
        </Typography>
      </Stack>
    </Box>
  );
};

export default CarrierNotesFooter;
